import type { ContactPerson } from '@interfaces/contact.interface';

import { FIRST_NAMES, LAST_NAMES } from '../pools';
import { pick, randomEmail, randomPhone, uuid } from '../utils';

export function buildContactPerson(overrides?: Partial<ContactPerson>): ContactPerson {
  const name = pick(FIRST_NAMES);
  const lastName = pick(LAST_NAMES);
  return {
    id: uuid(),
    name,
    lastName,
    email: randomEmail(name, lastName),
    phone: randomPhone(),
    ...overrides,
  };
}

export function buildContactPersons(count: number): ContactPerson[] {
  return Array.from({ length: count }, () => buildContactPerson());
}
